import { render, staticRenderFns } from "./LoanGuide.vue?vue&type=template&id=60c8e115&scoped=true&"
import script from "./LoanGuide.vue?vue&type=script&lang=js&"
export * from "./LoanGuide.vue?vue&type=script&lang=js&"
import style0 from "./LoanGuide.vue?vue&type=style&index=0&id=60c8e115&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c8e115",
  null
  
)

export default component.exports